export var BI_APP_NAME = 'Stores';
export var RestCommands;
(function (RestCommands) {
    RestCommands["CartRemoveItem"] = "RemoveCartItemCommand";
    RestCommands["CartUpdateItem"] = "UpdateCartItemCommand";
    RestCommands["CartUpdateBuyerNote"] = "UpdateBuyerNoteToCartCommand";
    RestCommands["CartSetCartDestinationForEstimation"] = "SetCartDestinationForEstimationCommand";
    RestCommands["SetCartShippingAddressesForFastFlowEstimation"] = "SetCartShippingAddressesForFastFlowEstimationCommand";
    RestCommands["SetCartAddressesAndDestinationFromSingleAddress"] = "SetCartAddressesAndDestinationFromSingleAddressCommand";
    RestCommands["SetCartBillingAddress"] = "SetCartBillingAddressCommand";
    RestCommands["CartSelectShippingOption"] = "SelectShippingOption";
    RestCommands["CartApplyCoupon"] = "SetCartCouponCommand2";
    RestCommands["CartRemoveCoupon"] = "RemoveCouponFromCartCommand";
})(RestCommands || (RestCommands = {}));
export var PLACE_ORDER_URL = '/_api/wix-ecommerce-renderer-web/store-front/checkout/cart/{cartId}/placeOrder';
export var GraphQLOperations;
(function (GraphQLOperations) {
    GraphQLOperations["GetCartService"] = "getCartService";
    GraphQLOperations["GetLocaleData"] = "getLocaleData";
    GraphQLOperations["GetAppSettings"] = "getAppSettings";
    GraphQLOperations["GetStoreMetaData"] = "getStoreMetaData";
    GraphQLOperations["GetCashierCheckoutData"] = "getCashierCheckoutData";
    GraphQLOperations["GetOrderData"] = "getOrderData";
})(GraphQLOperations || (GraphQLOperations = {}));
export var FedopsInteractions;
(function (FedopsInteractions) {
    FedopsInteractions["RemoveItemFromCart"] = "remove-item-interaction";
    FedopsInteractions["UpdateQuantityInCart"] = "update-quantity-interaction";
    FedopsInteractions["ApplyCouponInOrder"] = "apply-coupon-interaction";
    FedopsInteractions["ViewCheckoutInteraction"] = "view-checkout";
})(FedopsInteractions || (FedopsInteractions = {}));
export var CartEvents;
(function (CartEvents) {
    CartEvents["Changed"] = "Cart.Changed";
    CartEvents["Cleared"] = "Cart.Cleared";
})(CartEvents || (CartEvents = {}));
//# sourceMappingURL=constants.js.map